(() => {
  'use strict';
  if (window.PBLegacyCustomizerTracking) return;

  const script = document.currentScript;
  const productId = script?.dataset.pbProductId || '';
  const customizerType = script?.dataset.pbCustomizerType || '';
  const families = {
    photo_box_text_foil: 'photo_box',
    usb_box_text_foil_upsell: 'usb_box',
    photo_usb_box_text_foil_upsell: 'photo_usb_box',
    'pb-usb-box-customizer': 'usb_box',
    usb_box_text_foil: 'usb_box',
    standalone_usb_engraving_box_upsell: 'usb_drive',
    usb_text_engraving: 'usb_drive'
  };
  const productFamily = families[customizerType];
  if (!productId || !productFamily) return;

  const rootId = productFamily === 'usb_drive' ? 'PBStandaloneUSBCustomizer-' :
    productFamily === 'usb_box' || productFamily === 'photo_usb_box' ? 'PBUSBBoxCustomizer-' : 'PBPhotoBoxCustomizer-';
  const root = document.getElementById(rootId + productId);
  const modal = root?.querySelector('.pb-photo-customizer__modal');
  const openButton = root?.querySelector('.pb-photo-customizer__open');
  const message = modal?.querySelector('[data-pb-message]');
  if (!root || !modal || !openButton) return;

  const GA_DESTINATION = 'G-BH383LQYPZ';
  const rootPayload = { product_id: productId, product_family: productFamily, customizer_type: customizerType };
  const state = { openSent: false, edited: false, attempt: 0, errorReportedAttempt: 0, currentlyOpen: false };
  const initialValues = new WeakMap();
  const choiceAttrs = [
    'personalization', 'usb-engraving', 'box-personalization', 'box-choice', 'usb-choice',
    'color', 'foil', 'usb-capacity', 'usb-key', 'box-key', 'box-color', 'box-foil-name'
  ];
  const pathAttrs = new Set(['personalization', 'usb-engraving', 'box-personalization', 'box-choice', 'usb-choice']);

  function isInternalOrPreview() {
    try {
      const role = String(window.Shopify?.theme?.role || '').toLowerCase();
      const params = new URLSearchParams(window.location.search);
      return Boolean(window.PBQA?.isInternal || sessionStorage.getItem('pb_qa_mode') ||
        window.Shopify?.designMode || params.has('preview_theme_id') ||
        role === 'unpublished' || role === 'development');
    } catch (_) {
      return Boolean(window.PBQA?.isInternal || window.Shopify?.designMode);
    }
  }

  function track(name, details = {}) {
    if (isInternalOrPreview()) return;
    const payload = { send_to: GA_DESTINATION, ...rootPayload, ...details };
    const send = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function') {
        if (typeof window.Shopify?.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
            if (!error && typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') send();
          });
        }
        return;
      }
      if (!privacy.analyticsProcessingAllowed()) return;
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', name, payload);
        } else if (Array.isArray(window.dataLayer) &&
                   document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
          (function () { window.dataLayer.push(arguments); })('event', name, payload);
        }
        if (typeof window.clarity === 'function') {
          window.clarity('event', name);
          window.clarity('set', 'pb_customizer_family', productFamily);
        }
      } catch (_) { /* Never affect customization or purchase flow. */ }
    };
    send();
  }

  function beginEditing(interactionType) {
    if (state.edited) return;
    state.edited = true;
    track('personalization_start', { interaction_type: interactionType });
  }

  function selected(button) {
    return button.classList.contains('is-active') ||
      button.getAttribute('aria-pressed') === 'true' ||
      button.getAttribute('aria-selected') === 'true';
  }

  openButton.addEventListener('click', event => {
    if (!event.isTrusted) return;
    window.setTimeout(() => {
      if (modal.hidden) return;
      state.currentlyOpen = true;
      if (state.openSent) return;
      state.openSent = true;
      track('customizer_open');
    }, 0);
  });

  modal.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const button = event.target.closest('button,[data-pb-close]');
    if (!button || !modal.contains(button)) return;
    if (button.matches('[data-pb-close]')) {
      if (state.currentlyOpen) track('customizer_close');
      state.currentlyOpen = false;
      return;
    }
    if (button.matches('[data-pb-add]')) {
      state.attempt += 1;
      track('customizer_add_attempt');
      return;
    }
    const attr = choiceAttrs.find(key => button.hasAttribute('data-' + key));
    if (!attr || selected(button) || button.disabled) return;
    const value = button.getAttribute('data-' + attr) || '';
    if (pathAttrs.has(attr)) {
      track('customizer_path_select', { choice_group: attr.replace(/-/g, '_'), choice_value: value.slice(0, 64) });
    }
    beginEditing(attr.replace(/-/g, '_'));
  }, true);

  modal.addEventListener('focusin', event => {
    const field = event.target;
    if (field.matches('input,textarea,select')) initialValues.set(field, field.value || '');
  });

  function fieldChanged(event) {
    if (!event.isTrusted) return;
    const field = event.target;
    if (!field.matches('input,textarea,select') || field.disabled || field.readOnly) return;
    if (field.matches('input[type="hidden"],input[type="number"],[data-pb-quantity-input]')) return;
    const value = String(field.value || '');
    const previous = initialValues.has(field) ? String(initialValues.get(field)) : '';
    if (value && value !== previous) beginEditing(field.matches('select') ? 'select_change' : 'text_or_file_edit');
    initialValues.set(field, value);
  }
  modal.addEventListener('input', fieldChanged);
  modal.addEventListener('change', fieldChanged);

  if (message && typeof MutationObserver === 'function') {
    const observer = new MutationObserver(() => {
      if (!state.attempt || state.errorReportedAttempt === state.attempt) return;
      if (!message.hidden && message.textContent.trim()) {
        state.errorReportedAttempt = state.attempt;
        track('customizer_add_error', { error_category: 'customer_visible_error' });
      }
    });
    observer.observe(message, { attributes: true, childList: true, characterData: true, subtree: true });
  }

  window.PBLegacyCustomizerTracking = { version: '1.0', productFamily, productId };
})();
